var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("dataScreening", {
            attrs: {
              propsData: {
                isCurrency: true,
                isPayChannel: true,
                adChannel: false,
                adPlacement: false,
                isCountry: false
              }
            },
            on: {
              searchChange: _vm.searchChange,
              currencyChange: _vm.currencyChange
            }
          }),
          _vm.rawData.game_mark.indexOf("royalpirates") > -1
            ? _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: _vm.$t("selectEnvironment")
                      },
                      on: { change: _vm.severlistChange },
                      model: {
                        value: _vm.searchData.is_prod,
                        callback: function($$v) {
                          _vm.$set(_vm.searchData, "is_prod", $$v)
                        },
                        expression: "searchData.is_prod"
                      }
                    },
                    _vm._l(_vm.severlist, function(item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.rawData.game_mark.indexOf("royalpirates") > -1
            ? _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        multiple: "",
                        "collapse-tags": "",
                        clearable: "",
                        filterable: "",
                        placeholder: _vm.$t("pleaseSelectServer")
                      },
                      on: { change: _vm.royalSeverChange },
                      model: {
                        value: _vm.searchData.server_id,
                        callback: function($$v) {
                          _vm.$set(_vm.searchData, "server_id", $$v)
                        },
                        expression: "searchData.server_id"
                      }
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          on: { change: _vm.selecRotAll },
                          model: {
                            value: _vm.checked,
                            callback: function($$v) {
                              _vm.checked = $$v
                            },
                            expression: "checked"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("selectAll")))]
                      ),
                      _vm._l(_vm.serverLists, function(item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: {
                            label: item.name || item.serverName,
                            value: item.id || item.serverID
                          }
                        })
                      })
                    ],
                    2
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.rawData.game_mark.indexOf("yjfm") > -1
            ? _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "flex-1",
                      attrs: {
                        filterable: "",
                        placeholder: _vm.$t("selectEnvironment")
                      },
                      on: { change: _vm.envIdChangeN },
                      model: {
                        value: _vm.searchData.env_id,
                        callback: function($$v) {
                          _vm.$set(_vm.searchData, "env_id", $$v)
                        },
                        expression: "searchData.env_id"
                      }
                    },
                    _vm._l(_vm.szgmEnv, function(item) {
                      return _c("el-option", {
                        key: item.label,
                        attrs: { label: item.label, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.rawData.game_mark.indexOf("yjfm") > -1
            ? _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: _vm.$t("serverChannel")
                      },
                      on: { change: _vm.serverChange },
                      model: {
                        value: _vm.server_channel,
                        callback: function($$v) {
                          _vm.server_channel = $$v
                        },
                        expression: "server_channel"
                      }
                    },
                    _vm._l(_vm.serverChannel, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.rawData.game_mark.indexOf("yjfm") > -1
            ? _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: _vm.$t("showTestServer")
                      },
                      on: { change: _vm.serverChannelChange },
                      model: {
                        value: _vm.show_test,
                        callback: function($$v) {
                          _vm.show_test = $$v
                        },
                        expression: "show_test"
                      }
                    },
                    _vm._l(_vm.serverType, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.rawData.game_mark.indexOf("yjfm") > -1
            ? _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        multiple: "",
                        "collapse-tags": "",
                        clearable: "",
                        filterable: "",
                        placeholder: _vm.$t("server")
                      },
                      on: { change: _vm.severChange },
                      model: {
                        value: _vm.searchData.server_id,
                        callback: function($$v) {
                          _vm.$set(_vm.searchData, "server_id", $$v)
                        },
                        expression: "searchData.server_id"
                      }
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          on: { change: _vm.selectAll },
                          model: {
                            value: _vm.checked,
                            callback: function($$v) {
                              _vm.checked = $$v
                            },
                            expression: "checked"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("selectAll")))]
                      ),
                      _vm._l(_vm.serverListYJ, function(item) {
                        return _c("el-option", {
                          key: item.serverID,
                          attrs: {
                            label: item.serverName,
                            value: item.serverID
                          }
                        })
                      })
                    ],
                    2
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.rawData.game_mark.indexOf("royalpirates") == -1 &&
          _vm.rawData.game_mark.indexOf("yjfm") == -1
            ? _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c("el-input", {
                    attrs: {
                      clearable: "",
                      filterable: "",
                      placeholder: _vm.$t("serverId")
                    },
                    model: {
                      value: _vm.searchData.server_id,
                      callback: function($$v) {
                        _vm.$set(_vm.searchData, "server_id", $$v)
                      },
                      expression: "searchData.server_id"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.exportdata } },
                [_vm._v(_vm._s(_vm.$t("export")))]
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function($event) {
                      return _vm.getList(1)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("search")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.reqLoading,
              expression: "reqLoading"
            }
          ],
          attrs: { data: _vm.tableData, border: "" }
        },
        _vm._l(_vm.tableColumn, function(item, index) {
          return _c("el-table-column", {
            key: "desk" + item.prop,
            attrs: { prop: item.prop, label: item.label }
          })
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }